import { screenActions } from '../../services';

let isTouch;

function isTouchDevice() {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split( ' ' );
  const mq = query => window.matchMedia( query ).matches;
  const isFirefox = navigator.userAgent.toLowerCase().indexOf( 'firefox' ) > -1;
  let isTouchDeviceProbability = 0;
  
  //Reduce probability for firefox
  if( isFirefox ) {
    isTouchDeviceProbability -= 33;
  }

  if ( 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ) {
    isTouchDeviceProbability += 33;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join( 'touch-enabled),(' ), 'heartz', ')'].join( '' );

  if( mq( query ) ) {
    isTouchDeviceProbability += 33;
  }

  if( navigator.userAgent.match( /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i ) ) {
    isTouchDeviceProbability += 33;
  }
  
  return isTouch = isTouchDeviceProbability > 50;
}

const getState = () => {
  if( isTouch !== undefined && !isTouch || !isTouchDevice() ) {
    return {
      isMobile: false,
      isTablet: false
    };
  }

  const smallerSide = Math.min( window.innerWidth, window.innerHeight );

  return {
    isMobile: smallerSide <= 600,
    isTablet: smallerSide > 600 && smallerSide <= 800
  };
};

export const screenReducer = ( state = getState(), action ) => {
  switch ( action.type ) {
    case screenActions.RESIZE:
      return getState();
    default:
      return state;
  }
};